import React from "react";
import { Rate, Form } from "antd";

const AdnRate = ({
    name,
    label,
    defaultValue,
    disabled,
    value,
    handleChange,
    rules,
    style,
    className
}) => {
    return (
        <Form.Item name={name} label={label} rules={rules}>
            <Rate
                disabled={disabled}
                defaultValue={defaultValue}
                value={value}
                onChange={handleChange}
                allowHalf
                style={style}
                className={className}
            />
        </Form.Item>
    );
};

export default AdnRate;
